<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content style="font-family: Roboto;">
  {{data.message}}
</div>
<mat-dialog-actions> 
 
  <button mat-raised-button color="warn" [mat-dialog-close]="true">DELETE</button>
  
  <button mat-button  [mat-dialog-close]="false">CANCEL</button>
</mat-dialog-actions>